// extracted by mini-css-extract-plugin
export default {"container":"InventorySheetSummaryTooltip_container__HWbXA"};